export const BACKENDURL = window.location.origin;
